import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AjaxService from 'lumen/services/ajax';

export interface Pms {
  display_name: string;
  id: number;
}

interface PmsWithVersion extends Pms {
  version_determination_help_article: string;
  versions: Pms[];
}

interface PmsVersionsResponse {
  pmss: PmsWithVersion[];
}

export default class HotelSettingsMyotbPmsSelectionRoute extends Route {
  @service declare ajax: AjaxService;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async model() {
    const pmsVersionsResponse = await this.ajax.request<PmsVersionsResponse>(
      '/api/v3/pmsversions/',
    );

    return {
      pmsVersions: pmsVersionsResponse.pmss,
    };
  }
}
